(function () {
  const STORAGE_KEY = 'pp_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    try {
      // Limite la liste aux 50 derniers éléments pour éviter de saturer le localStorage
      const trimmedList = list.slice(-50);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmedList));
    } catch (e) {
      if (e.name === 'QuotaExceededError' || e.code === 22) {
        console.warn('LocalStorage saturé. Nettoyage d\'urgence de la liste d\'envies...');
        try {
          // Si le quota est dépassé, on réduit drastiquement aux 10 derniers éléments
          const emergencyList = list.slice(-10);
          localStorage.setItem(STORAGE_KEY, JSON.stringify(emergencyList));
        } catch (innerError) {
          // Solution de secours ultime si l'espace est complètement bloqué
          localStorage.removeItem(STORAGE_KEY);
        }
      } else {
        console.error('Erreur lors de la sauvegarde de la wishlist :', e);
      }
    }
  }

  function toggle(id, btn) {
    let list = getWishlist();
    const idx = list.indexOf(id);
    if (idx > -1) {
      list.splice(idx, 1);
      btn.classList.remove('is-active');
      if (window.ppToast) window.ppToast('Retir\u00e9 de vos favoris', { type: 'wishlist' });
    } else {
      list.push(id);
      btn.classList.add('is-active');
      if (window.ppToast) window.ppToast('Ajout\u00e9 \u00e0 vos favoris', { type: 'wishlist' });
    }
    saveWishlist(list);
    updateBubble();
  }

  function updateBubble() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  /* ── Applique l'etat "is-active" sur tous les coeurs presents dans le DOM.
     Appele au chargement ET a chaque fois qu'un MutationObserver detecte
     de nouveaux boutons (grille filtree/triee en AJAX, scroll infini,
     modale quick-add) puisque ces re-rendus ne declenchent pas
     'shopify:section:load' (reserve a l'editeur de theme). ────────────── */
  function applyActiveStates(root) {
    const list = getWishlist();
    (root || document).querySelectorAll('.pp-wishlist-btn').forEach(btn => {
      const id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', list.includes(id));
    });
  }

  /* ── Delegation d'evenements sur document : un seul listener, valable
     pour tous les boutons presents ET futurs (grilles rechargees en AJAX
     par les filtres/tri/scroll infini, modale quick-add, page liste
     d'envies). ─────────────────────────────────────────────── */
  document.addEventListener('click', (e) => {
    const wishlistBtn = e.target.closest('.pp-wishlist-btn');
    if (wishlistBtn) {
      e.preventDefault();
      toggle(wishlistBtn.getAttribute('data-product-id'), wishlistBtn);
      return;
    }

    const help = e.target.closest('.pp-wishlist-help');
    if (help) {
      e.stopPropagation();
      document.querySelectorAll('.pp-wishlist-help').forEach(h => {
        if (h !== help) h.classList.remove('pp-tooltip-open');
      });
      help.classList.toggle('pp-tooltip-open');
      return;
    }

    document.querySelectorAll('.pp-wishlist-help').forEach(h => h.classList.remove('pp-tooltip-open'));
  });

  function initButtons() {
    applyActiveStates();
    updateBubble();
  }

  /* ── Reapplique l'etat des coeurs des qu'un nouveau bouton apparait
     dans le DOM (filtre/tri AJAX, scroll infini, modale quick-add). ── */
  const ppWishlistObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('.pp-wishlist-btn')) {
          applyActiveStates(node.parentNode || document);
        } else if (node.querySelector && node.querySelector('.pp-wishlist-btn')) {
          applyActiveStates(node);
        }
      }
    }
  });
  ppWishlistObserver.observe(document.documentElement, { childList: true, subtree: true });

  /* FIX 22/08 (retour Sid : "ne fonctionnait pas tres bien") :
     - Chargement EN PARALLELE (Promise.all) au lieu d'un fetch a la fois
       en sequence — avec plusieurs favoris, la page mettait un temps
       visible a se remplir, produit par produit.
     - AUTO-NETTOYAGE : un handle localStorage qui ne correspond plus a
       un produit reel (ancien format d'ID numerique d'une version
       precedente du bouton, produit supprime/depublie...) echouait
       silencieusement (juste un console.error) et le favori disparaissait
       de la page sans explication, en laissant l'entree cassee dans
       localStorage pour toujours. Desormais, toute entree invalide est
       automatiquement retiree de la liste au premier passage sur la page
       — le compteur et la liste restent coherents dans la duree. */
  async function renderWishlistPage() {
    const grid = document.getElementById('pp-wishlist-grid');
    if (!grid) return;

    const loading = document.getElementById('pp-wishlist-loading');
    const emptyMsg = document.getElementById('pp-wishlist-empty');
    const handles = getWishlist();

    if (handles.length === 0) {
      if (loading) loading.style.display = 'none';
      emptyMsg.style.display = 'block';
      grid.innerHTML = '';
      return;
    }

    const results = await Promise.all(handles.map(async (handle) => {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) return { handle, product: null };
        return { handle, product: await res.json() };
      } catch (e) {
        return { handle, product: null };
      }
    }));

    const validProducts = [];
    const invalidHandles = [];
    results.forEach(({ handle, product }) => {
      if (product) validProducts.push(product);
      else invalidHandles.push(handle);
    });

    if (invalidHandles.length > 0) {
      const cleaned = handles.filter((h) => !invalidHandles.includes(h));
      saveWishlist(cleaned);
      updateBubble();
      console.warn('Favoris invalides retires automatiquement :', invalidHandles);
    }

    if (loading) loading.style.display = 'none';

    if (validProducts.length === 0) {
      emptyMsg.style.display = 'block';
      grid.innerHTML = '';
      return;
    }

    emptyMsg.style.display = 'none';

    /* Cartes paysage — meme look que les cartes des pages collection */
    grid.innerHTML = validProducts.map(p => `
      <li class="pp-wishlist-card">
        <a href="${p.url}" class="pp-wishlist-card__media">
          <img src="${p.featured_image}" alt="${(p.title || '').replace(/"/g, '&quot;')}" loading="lazy">
        </a>
        <div class="pp-wishlist-card__info">
          <a href="${p.url}" class="pp-wishlist-card__title">${p.title}</a>
          <div class="pp-wishlist-card__price">${(p.price / 100).toFixed(2).replace('.', ',')} \u20ac</div>
          <div class="pp-card-actions">
            <a href="${p.url}" class="button button--primary pp-wishlist-view">Voir le produit</a>
            <button type="button" class="pp-wishlist-remove" data-product-id="${p.handle}">\u2715 Retirer</button>
          </div>
        </div>
      </li>
    `).join('');

    grid.querySelectorAll('.pp-wishlist-remove').forEach(btn => {
      btn.addEventListener('click', () => {
        const handle = btn.getAttribute('data-product-id');
        let list = getWishlist();
        list = list.filter(h => h !== handle);
        saveWishlist(list);
        renderWishlistPage();
        updateBubble();
      });
    });
  }

  function initModalCarousel() {
    document.querySelectorAll('product-modal').forEach(modal => {
      const items = modal.querySelectorAll('.pp-modal-item');
      const prevBtn = modal.querySelector('.pp-modal-nav--prev');
      const nextBtn = modal.querySelector('.pp-modal-nav--next');
      const content = modal.querySelector('.product-media-modal__content');
      if (!items.length || modal.dataset.ppInit) return;
      modal.dataset.ppInit = 'true';

      let current = 0;
      function show(i) {
        items.forEach(item => item.classList.remove('pp-active'));
        current = (i + items.length) % items.length;
        items[current].classList.add('pp-active');
      }
      show(0);

      function handleNav(e, direction) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        show(current + direction);
        return false;
      }

      [prevBtn, nextBtn].forEach((btn, i) => {
        if (!btn) return;
        const direction = i === 0 ? -1 : 1;
        btn.addEventListener('click', (e) => handleNav(e, direction), true);
        btn.addEventListener('pointerdown', (e) => e.stopPropagation(), true);
        btn.addEventListener('pointerup', (e) => e.stopPropagation(), true);
      });

      modal.ppShow = show;
      modal.ppGetCurrent = function () { return current; };

      function lockScroll() { document.body.style.overflow = 'hidden'; }
      function unlockScroll() { document.body.style.overflow = ''; }

      const observer = new MutationObserver(() => {
        if (modal.hasAttribute('open')) {
          lockScroll();
        } else {
          unlockScroll();
        }
      });
      observer.observe(modal, { attributes: true, attributeFilter: ['open'] });

      if (content) {
        let touchStartX = 0;
        let touchStartY = 0;
        let isHorizontalSwipe = null;

        content.addEventListener('touchstart', (e) => {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          isHorizontalSwipe = null;
        }, { passive: true });

        content.addEventListener('touchmove', (e) => {
          const deltaX = e.touches[0].clientX - touchStartX;
          const deltaY = e.touches[0].clientY - touchStartY;

          if (isHorizontalSwipe === null) {
            isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
          }

          if (isHorizontalSwipe) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, { passive: false });

        content.addEventListener('touchend', (e) => {
          if (!isHorizontalSwipe) return;
          const deltaX = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(deltaX) < 50) return;

          e.preventDefault();
          e.stopPropagation();

          if (deltaX < 0) {
            show(current + 1);
          } else {
            show(current - 1);
          }
        }, { passive: false });
      }
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    const modal = document.querySelector('product-modal[open]');
    if (!modal || typeof modal.ppShow !== 'function') return;
    e.preventDefault();
    const dir = e.key === 'ArrowLeft' ? -1 : 1;
    modal.ppShow(modal.ppGetCurrent() + dir);
  });

  document.addEventListener('DOMContentLoaded', initButtons);
  document.addEventListener('shopify:section:load', initButtons);
  document.addEventListener('DOMContentLoaded', renderWishlistPage);
  document.addEventListener('DOMContentLoaded', initModalCarousel);
  document.addEventListener('shopify:section:load', initModalCarousel);
})();
